import { Box, styled } from '@mui/material';

import { Spacing } from 'Themes/spacing';

export const SingleLine = styled(Box)`
  display: flex;
  gap: ${Spacing.xsmall};
`;
